import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { StyledProps } from 'types/styles';

interface Props extends StyledProps {}

export const StepperWrapper = styled.div<Props>`
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: space-between;
  margin-bottom: ${themeGet('space.8')}px;
`;

export const HeaderContainer = styled.div<Props>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  position: relative;
`;

export const BackButtonContainer = styled.div<Props>`
  display: flex;
  align-items: center;
  position: absolute;
  left: 0;
`;

export const LogoContainer = styled.div<Props>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

export const ProgressBarWithStepsContainer = styled.div<Props>`
  margin-top: ${themeGet('space.8')}px;
`;
